import React, { useContext, useEffect, useState, useRef } from "react";
import Select from "react-select";
import { SiAdblock } from "react-icons/si";
import swal from "sweetalert";
import {
  FaMoneyBill,
  FaUser,
  FaEllipsisV,
  FaFlag,
  FaBan,
  FaIcons,
  FaTimes,
} from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import {
  Badge,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import "../../index.css";
import "bootstrap/dist/css/bootstrap.min.css"; 
import { PiDotsThreeOutlineVerticalBold } from "react-icons/pi";
import { IoIosSend } from "react-icons/io";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { Addtaskadmin, DependencyModal, Dependencytable } from "../Modal";
import { FiCalendar, FiUser, FiPaperclip, FiClipboard, FiSearch, FiPlus, FiArrowLeft } from "react-icons/fi";
import { FaFileAlt } from "react-icons/fa";
import { GrEdit } from "react-icons/gr";
import { IoMdPersonAdd } from "react-icons/io";
import { AiFillEye } from "react-icons/ai";
import "./Taskmanagementadmin.css";
const Taskmanagementadmin = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [taskdata, setTaskData] = useState([]);
  const [PriorityFilter, setPriorityFilter] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [platformFilter, setPlatformFilter] = useState(null);
  const { password, username } = billpunchbasicauth;

  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [showaddsubtaskModal, setshowaddsubtaskModal] = useState(false);
  const [showdependency, setshowdependency] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [Dependencymodal, setDependencymodal] = useState(false);
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [dependencyTaskId, setDependencyTaskId] = useState(null);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const togglePopover = (taskId) => {
    setOpenPopoverId(openPopoverId === taskId ? null : taskId);
  };
  const opendependency = () => {
    setDependencymodal(true);
  };

  const closedependency = () => {
    setDependencymodal(false);
  };
  const openaddsubtaskModal = () => {
    setshowaddsubtaskModal(true);
  };
  const closeaddsubtaskModal = () => {
    setshowaddsubtaskModal(false);
  };
  const opendependencymodal = (taskId) => {
    setDependencyTaskId(taskId);
    setshowdependency(true);
    setCurrentTaskId(taskId);
  };

  const closedependencymodal = () => {
    setshowdependency(false);
  };
  const filteredTaskData = taskdata.filter((item) => {
    const priorityMatch =
      !PriorityFilter ||
      PriorityFilter.value === "Clear" ||
      item.task_priority === PriorityFilter.value;
    const platformMatch =
      !platformFilter ||
      platformFilter.value === "clear" ||
      item.platform === platformFilter.label;
    const categoryMatch =
      !categoryFilter ||
      categoryFilter.value === "clear" ||
      item.category === categoryFilter.label;
      
    const searchMatch =
      searchQuery === "" ||
      item.taskname.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.task_description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.task_startdate.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.task_enddate.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.platform.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.status.toLowerCase().includes(searchQuery.toLowerCase());
    const statusMatch = !statusFilter || !statusFilter.value || item.status === statusFilter.value;
    return priorityMatch && platformMatch && searchMatch && categoryMatch && statusMatch;
  }).sort((a, b) => {
    const latestDate = (Date.parse(b.task_startdate) || 0) - (Date.parse(a.task_startdate) || 0);
    return latestDate || Number(b.pk_taskid || b.pk_task_id || 0) - Number(a.pk_taskid || a.pk_task_id || 0);
  });

  const taskdataobject = JSON.parse(sessionStorage.getItem("taskdata"));
  // console.log(taskdataobject, "taskdataobject");
  const propertyobject = JSON.parse(sessionStorage.getItem("property"));
  const fetchCategories = async () => {
    try {
       const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({  firmid:user.firm_id, }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetCatTask`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        const fetchedCategories = data.data.map((cat) => ({
          value: cat.pk_catid,
          label: cat.catname,
        }));
        setCategories(fetchedCategories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setCategoryFilter(selectedOption);
  };
  const getTask = async () => {
    setTransactionLoaderState(true);
    try {
       const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        spaceid: propertyobject.pk_work_id,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskEmployee`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setTaskData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const [status, setstatus] = useState();
  const Updatestatus = async (spaceID, taskId) => {
    setTransactionLoaderState(true);
    try {
       const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        spaceid: spaceID,
        projectid: propertyobject.pk_project_id,
        taskid: taskId,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/ChangeTaskStatus`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setstatus(data.data);
        getTask();
        swal("Success", data.result, "success");
      } else {
        swal("Error", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const options = [
    {
      value: "Urgent",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "maroon" }} />
          Urgent
        </div>
      ),
    },
    {
      value: "High",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "#f4c430" }} />
          High
        </div>
      ),
    },
    {
      value: "Normal",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "blue" }} />
          Normal
        </div>
      ),
    },
    {
      value: "Low",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "grey" }} />
          Low
        </div>
      ),
    },
    {
      value: "Clear",
      label: (
        <div>
          {" "}
          <img
            src={require("../../assets/images/flag_1.png")}
            style={{ marginRight: "5px", width: ".8rem" }}
          />
          Clear
        </div>
      ),
    },
  ];
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const [editableTaskId, setEditableTaskId] = useState(null);
  const [editedTaskName, setEditedTaskName] = useState("");

  const handleTaskNameEdit = (taskId, taskName) => {
    setEditableTaskId(taskId);
    setEditedTaskName(taskName);
  };

  const taskdetails = JSON.parse(sessionStorage.getItem("taskdetails"));
  const handleTaskNameUpdate = async (e, pk_taskid) => {
    e.preventDefault();
    try {
      console.log("Inside handleSubmit");
       const base64Credentials = btoa(`${username}:${password}`);
      var raw = JSON.stringify({
        empid: user.userid,
        taskid: pk_taskid,
        taskname: editedTaskName,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };
      console.log("sending data to abhijeet");
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/RenameTaskname`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "1") {
        swal("Error", data.msg, "error");
        setEditableTaskId(null);
        getTask();
      } else {
        swal("Success", data.msg, "success");
        setEditableTaskId(null);
        getTask();
      }
      console.log("Form submission completed.");
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const fetchPlatforms = async () => {
    try {
       const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ taskid: "string" }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskPlatform`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        const fetchedPlatforms = data.data.map((device) => ({
          value: device.pk_platformid,
          label: device.platform_name,
        }));
        setPlatforms(fetchedPlatforms);
      }
    } catch (error) {
      console.error("Error fetching platforms:", error);
    }
  };
  const handlePlatformChange = (selectedOption) => {
    setPlatformFilter(selectedOption);
  };

  useEffect(() => {
    getTask();
    fetchPlatforms();
    fetchCategories();
  }, []);

  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessData);
  }, [accessData]);
  const popoverStyle = {
    background: "#fff",
    width: "15vw",
    position: "absolute",
    zIndex: 1,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
  };
  const linkStyle = {
    fontSize: ".8rem", textDecoration:"none "
  };
  const calculatePopoverPosition = (iconRef) => {
    if (!iconRef) return {};

    const iconPosition = iconRef.getBoundingClientRect();
    const popoverTop = iconPosition.top + iconPosition.height + 10; 
    const popoverLeft = iconPosition.left + iconPosition.width / 2;

    return {
      ...popoverStyle,
      top: `${popoverTop}px`,
      left: `${popoverLeft}px`,
      transform: "translateX(-50%)",
    };
  };
  const iconRefs = useRef({});
  const formatDescription = description => String(description || "").split("\n").filter(point => point.trim()).map((point, index) => <li key={index}>{point}</li>);
  const formatTaskDate = value => {
    if (!value) return "—";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  };
  const createTaskRoles = (accessData || []).flatMap(module => module.data || []).filter(role => role.role_name === "Add Tasks");
  const canCreateTask = createTaskRoles.some(role => role.access === "Y");
  return (
    <div className="aw-page">
      <Addtaskadmin
        show={showaddsubtaskModal}
        closeModal={closeaddsubtaskModal}
        getSubsubTask={getTask}
        pk_work_id={propertyobject.pk_work_id}
        pk_project_id={propertyobject.pk_project_id}
      />
      <DependencyModal
        show={Dependencymodal}
        closeModal={closedependency}
        getTask={getTask}
      />
      <Dependencytable
        taskId={currentTaskId}
        show={showdependency}
        closeModal={closedependencymodal}
        dependencyTaskId={dependencyTaskId}
      />
      <header className="aw-header">
        <h1>{propertyobject.workspace_name || "Overall"}</h1>
        <div className="aw-header-actions">
          <Link to="/admin/work-dashboard" className="aw-back">
            <FiArrowLeft />
            Back
          </Link>
          {createTaskRoles.length > 0 && (
            <button
              type="button"
              size="sm"
              className="aw-add-task"
              disabled={!canCreateTask}
              onClick={openaddsubtaskModal}
            >
              <FiPlus />
              Add Task
            </button>
          )}
        </div>
      </header>
      <div className="aw-filters">
        <Select
          aria-label="Priority"
          placeholder="Priority"
          className="aw-select"
          classNamePrefix="aw-select"
          options={options}
          value={PriorityFilter}
          onChange={setPriorityFilter}
        />
        <Select
          aria-label="Platform"
          placeholder="Platform"
          className="aw-select"
          classNamePrefix="aw-select"
          options={[{ value: "clear", label: "Clear" }, ...platforms]}
          value={platformFilter}
          onChange={handlePlatformChange}
        />
        <Select
          aria-label="Category"
          placeholder="Category"
          className="aw-select"
          classNamePrefix="aw-select"
          options={[{ value: "clear", label: "Clear" }, ...categories]}
          value={categoryFilter}
          onChange={handleCategoryChange}
        />
        <Select
          aria-label="Task status"
          placeholder="Status"
          className="aw-select"
          classNamePrefix="aw-select"
          isClearable
          options={[
            { value: "", label: "All Statuses" },
            { value: "P", label: "Pending" },
            { value: "O", label: "Overdue" },
            { value: "C", label: "Complete" },
          ]}
          value={statusFilter}
          onChange={setStatusFilter}
        />
        <label className="aw-search">
          <FiSearch />
          <input
            aria-label="Search tasks"
            placeholder="Search Task..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </label>
      </div>
      <div className="aw-cards">
        {filteredTaskData.length === 0 ? (
          <div className="aw-empty">No tasks found.</div>
        ) : (
          filteredTaskData.map((item) => (
            <article
              className="aw-task-card"
              key={item.pk_taskid || item.pk_task_id}
            >
              <div className="aw-description">
                <span
                  className="aw-priority"
                  title={item.task_priority || "No priority"}
                  style={{
                    color:
                      {
                        Urgent: "#de1725",
                        High: "#ffbd15",
                        Normal: "#1675ff",
                        Low: "#8d99aa",
                        Clear: "#c8d0dc",
                      }[item.task_priority] || "#c8d0dc",
                  }}
                >
                  <FaFlag />
                </span>
                <div className="aw-description-content">
                  <div className="aw-task-heading">
                    {editableTaskId === item.pk_taskid ? (
                      <form className="aw-rename" onSubmit={event => handleTaskNameUpdate(event, item.pk_taskid)}>
                        <input aria-label="Task name" autoFocus value={editedTaskName} onChange={event => setEditedTaskName(event.target.value)} />
                        <button type="submit" aria-label="Save task name" title="Save task name"><IoIosSend /></button>
                        <button type="button" onClick={() => setEditableTaskId(null)}>Cancel</button>
                      </form>
                    ) : (
                    <Link
                      to="/admin/Subtask-management"
                      onClick={() =>
                        sessionStorage.setItem(
                          "taskdetails",
                          JSON.stringify(item),
                        )
                      }
                    >
                      {item.taskname}
                      {item.platform ? ` (${item.platform})` : ""}
                    </Link>
                    )}
                    {item.platform && (
                      <span className="aw-platform">{item.platform}</span>
                    )}
                    {item.dependency_status === "Y" && (
                      <button
                        type="button"
                        className="aw-dependency-indicator"
                        title="View task dependencies"
                        onClick={() => opendependencymodal(item.pk_taskid)}
                      >
                        <SiAdblock />
                      </button>
                    )}
                  </div>
                  <Link
                    className="aw-description-link"
                    to="/admin/Subtask-management"
                    onClick={() =>
                      sessionStorage.setItem(
                        "taskdetails",
                        JSON.stringify(item),
                      )
                    }
                  >
                    <ul>{formatDescription(item.task_description)}</ul>
                  </Link>
                </div>
              </div>
              <div className="aw-metadata">
                <div className="aw-meta-row">
                  <FiCalendar />
                  <div>
                    <span>Date</span>
                    <p>
                      {formatTaskDate(item.task_startdate)} -{" "}
                      {formatTaskDate(item.task_enddate)}
                    </p>
                  </div>
                </div>
                <div className="aw-meta-row">
                  <FiUser />
                  <div>
                    <span>Assignee</span>
                    <p>{item.task_assignee || "—"}</p>
                  </div>
                </div>
                <div className="aw-meta-row aw-file">
                  <FiPaperclip />
                  <span>File</span>
                  {item.issue?.trim() ? (
                    <a
                      href={item.issue}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Open task file"
                      aria-label={`Open file for ${item.taskname}`}
                    >
                      <FaFileAlt />
                    </a>
                  ) : (
                    <FaBan className="aw-no-file" title="No file attached" />
                  )}
                </div>
              </div>
              <div className="aw-task-controls">
                <div className="aw-meta-row aw-status-row">
                  <FiClipboard />
                  <div>
                    <span>Status</span>
                    <div className={`aw-status aw-status-${item.status}`}>
                      {{ O: "Overdue", P: "Pending", C: "Complete" }[
                        item.status
                      ] ||
                        item.status ||
                        "—"}
                    </div>
                  </div>
                  <Link
                    className="aw-view-subtask"
                    to="/admin/Subtask-management"
                    onClick={() => sessionStorage.setItem("taskdetails", JSON.stringify(item))}
                  >
                    View Subtask
                  </Link>
                </div>
                <div className="aw-meta-row aw-actions-row">
                  <FiPaperclip />
                  <div>
                    <span>Actions</span>
                    <div className="aw-actions">
                      <button
                        type="button"
                        className="aw-complete"
                        title="Mark Complete"
                        aria-label={`Mark ${item.taskname} complete`}
                        onClick={() =>
                          Updatestatus(item.fk_spaceid, item.pk_taskid)
                        }
                      >
                        <IoCheckmarkDoneCircle />
                      </button>
                      <button
                        type="button"
                        className="aw-edit"
                        title="Rename task"
                        aria-label={`Rename ${item.taskname}`}
                        onClick={() => handleTaskNameEdit(item.pk_taskid, item.taskname)}
                      >
                        <GrEdit />
                      </button>
                      <button
                        type="button"
                        className="aw-dependency"
                        title="Add dependency"
                        aria-label={`Add dependency to ${item.taskname}`}
                        onClick={() => {
                          sessionStorage.setItem(
                            "dependencytaskid",
                            JSON.stringify(item),
                          );
                          opendependency();
                        }}
                      >
                        <IoMdPersonAdd />
                      </button>
                      <button
                        type="button"
                        className="aw-view"
                        title="View dependencies"
                        aria-label={`View dependencies for ${item.taskname}`}
                        onClick={() => opendependencymodal(item.pk_taskid)}
                      >
                        <AiFillEye />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))
        )}
      </div>
    </div>
  );
};

export default Taskmanagementadmin;
